// extracted by mini-css-extract-plugin
export var center = "_1r-2";
export var clickableRow = "_1r-5";
export var expandedRow = "_1r-7";
export var hoverable = "_1r-4";
export var left = "_1r-1";
export var right = "_1r-3";
export var row = "_1r-0";
export var selectedRow = "_1r-6";
export var summaryRow = "_1r-8";